import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Button,
} from '@material-ui/core';
import { ModalIngresoInformeOftalmo } from './Oftalmologia/ModalIngresoInformeOftalmo';
import { HCE_PERMISOS } from '../../../../utils/permisos';
import { validarSoloUnPermiso } from '../../../../helpers/permisos';
import ChevronDown from '../../../empadronamiento/UI/ChevronDown';
import { traerInformesOftalmologia, traerProtocolosOftalmologia } from '../../../../actions/hce/hceActions';
import { InformesOftalmologiaHistorialItem } from './Oftalmologia/InformesOftalmologiaHistorialItem';

export const TabOftalmologia = (props) => {

  const { protocolosOftalmologia, informesOftalmologia } = useSelector((state) => state.hce);
  const { hce, disabled } = props;
  const dispatch = useDispatch();
  const [openModalOftalmo, setOpenModalOftalmo] = useState(false);
  const [tituloModal, setTituloModal] = useState('');
  const { permisos: permisosUser } = useSelector((state) => state.auth);


  useEffect(() => {
    dispatch(traerInformesOftalmologia(hce.idAfiliado, hce.idAfiliadoExterno));
    dispatch(traerProtocolosOftalmologia());
  }, [dispatch]);

  return (
    <React.Fragment>
      {openModalOftalmo && (
        <ModalIngresoInformeOftalmo
          open={openModalOftalmo}
          close={() => {
            setOpenModalOftalmo(false);
          }}
          titulo={tituloModal}
          disabled={props.disabled}
          hce={hce}
          protocolosOftalmologia={protocolosOftalmologia}
        />
      )}
      {validarSoloUnPermiso(permisosUser, HCE_PERMISOS.HCE) && (
        <div style={{ textAlign: 'center', margin: '1rem 0' }}>
          {!disabled &&
            <Button
              disabled={disabled}
              variant="contained"
              color="primary"
              onClick={() => {
                setTituloModal('Ingreso de informe');
                setOpenModalOftalmo(true);
                //dispatch(clearProtocolo());
              }}
            >
              + Ingresar Informe Oftalmología
            </Button>
          }
        </div>
      )}
      <Accordion TransitionProps={{ unmountOnExit: true }}>
        <AccordionSummary expandIcon={<ChevronDown />}>
          <Typography variant="h6">Historial de Informes oftalmologicos</Typography>
        </AccordionSummary>
        <AccordionDetails>
          {Array.isArray(informesOftalmologia) && informesOftalmologia?.length > 0 ? (
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell style={{ width: '20%' }}>Nombre Informe</TableCell>
                  <TableCell style={{ width: '20%' }}>Problema</TableCell>
                  <TableCell style={{ width: '20%' }}>
                    Nombre Profesional
                  </TableCell>
                  <TableCell style={{ width: '20%' }}>
                    Especialidad
                  </TableCell>
                  <TableCell style={{ width: '20%' }}>Fecha</TableCell>
                  <TableCell style={{ width: '20%' }}>Informe</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {informesOftalmologia.map((informe, index) => {
                  return (
                    <InformesOftalmologiaHistorialItem
                      key={informe?.id.toString()}
                      informe={informe}
                    />
                  );
                })}
              </TableBody>
            </Table>
          ) : (
            <Typography style={{ fontSize: '1.1rem', fontStyle: 'italic' }}>
              No se encuentran informes oftalmológicos
            </Typography>
          )}
        </AccordionDetails>
      </Accordion>
    </React.Fragment>
  );
};
